import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Card from '../../components/base/Card';
import Button from '../../components/base/Button';

export default function Catalogos() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showNewsletterModal, setShowNewsletterModal] = useState(false);
  const [newsletterData, setNewsletterData] = useState({
    nome: '',
    email: '',
    empresa: '',
    interesse: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const heroImages = [
    'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/6dd7c92f1eb8f0e6c1d25199c45c709d.png',
    'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/0f3d30b9627e4a037c0734fd2b35417c.png',
    'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/2fb7a8bc30438176229197d1da259b65.png',
    'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/8a62c8209992be080510b06fd0c0076f.png',
    'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/e727922dac05fb07e810cbec23df6894.png',
    'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/f588a039644bcabbd3cabf169717d59f.png'
  ];

  // Auto-rotate images
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === heroImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000); // Change image every 4 seconds

    return () => clearInterval(interval);
  }, [heroImages.length]);

  const catalogs = [
    {
      id: 1,
      title: 'Refresco 25 Litros - 250g',
      category: 'Bebidas',
      image: 'https://placehold.co/400x600/ef4444/ffffff?text=Catálogo+Tecnutri',
      description: 'Refresco em pó para preparo de 25 litros de bebida refrescante, ideal para estabelecimentos comerciais.',
      pages: '4 páginas',
      products: '12+ sabores',
      size: '2.1 MB',
      downloadUrl: '#',
      featured: true
    },
    {
      id: 2,
      title: 'Refresco 25 Litros - 500g',
      category: 'Bebidas',
      image: 'https://placehold.co/400x600/ef4444/ffffff?text=Catálogo+Tecnutri',
      description: 'Refresco em pó concentrado para preparo de 25 litros, versão econômica para alto volume.',
      pages: '4 páginas',
      products: '15+ sabores',
      size: '2.3 MB',
      downloadUrl: '#',
      featured: true
    },
    {
      id: 3,
      title: 'Tecnutri Food Service',
      category: 'Geral',
      image: 'https://placehold.co/400x600/ef4444/ffffff?text=Catálogo+Tecnutri',
      description: 'Catálogo completo com toda linha de produtos Tecnutri para food service e estabelecimentos comerciais.',
      pages: '48 páginas',
      products: '200+ produtos',
      size: '15.8 MB',
      downloadUrl: '#',
      featured: true
    },
    {
      id: 4,
      title: 'Refresco 25 Litros - 1Kg',
      category: 'Bebidas',
      image: 'https://placehold.co/400x600/ef4444/ffffff?text=Catálogo+Tecnutri',
      description: 'Refresco em pó para preparo de 25 litros, embalagem de 1kg para uso intensivo.',
      pages: '4 páginas',
      products: '18+ sabores',
      size: '2.5 MB',
      downloadUrl: '#',
      featured: false
    },
    {
      id: 5,
      title: 'Refresco 10 Litros - 200g',
      category: 'Bebidas',
      image: 'https://placehold.co/400x600/ef4444/ffffff?text=Catálogo+Tecnutri',
      description: 'Refresco em pó para preparo de 10 litros, ideal para estabelecimentos de menor porte.',
      pages: '4 páginas',
      products: '10+ sabores',
      size: '1.8 MB',
      downloadUrl: '#',
      featured: false
    },
    {
      id: 6,
      title: 'Purê Tecnutri',
      category: 'Culinários',
      image: 'https://placehold.co/400x600/ef4444/ffffff?text=Catálogo+Tecnutri',
      description: 'Mistura para purê instantâneo, prático e saboroso para acompanhar diversos pratos.',
      pages: '2 páginas',
      products: '5+ variedades',
      size: '1.2 MB',
      downloadUrl: '#',
      featured: false
    },
    {
      id: 7,
      title: 'Amaciante de Carnes',
      category: 'Culinários',
      image: 'https://placehold.co/400x600/ef4444/ffffff?text=Catálogo+Tecnutri',
      description: 'Amaciante natural para carnes, deixa a carne mais macia e saborosa.',
      pages: '2 páginas',
      products: '3+ tipos',
      size: '1.1 MB',
      downloadUrl: '#',
      featured: false
    },
    {
      id: 8,
      title: 'Gelatina 1Kg',
      category: 'Sobremesas',
      image: 'https://placehold.co/400x600/ef4444/ffffff?text=Catálogo+Tecnutri',
      description: 'Gelatina em pó sabores variados, embalagem de 1kg para uso comercial.',
      pages: '3 páginas',
      products: '+20 sabores',
      size: '1.5 MB',
      downloadUrl: '#',
      featured: false
    },
    {
      id: 9,
      title: 'Mousse',
      category: 'Sobremesas',
      image: 'https://placehold.co/400x600/ef4444/ffffff?text=Catálogo+Tecnutri',
      description: 'Mistura para mousse cremoso e aerado, diversos sabores disponíveis.',
      pages: '3 páginas',
      products: '15+ sabores',
      size: '1.4 MB',
      downloadUrl: '#',
      featured: false
    },
    {
      id: 10,
      title: 'Milanesa',
      category: 'Culinários',
      image: 'https://placehold.co/400x600/ef4444/ffffff?text=Catálogo+Tecnutri',
      description: 'Farinha para milanesa crocante e saborosa, ideal para empanados.',
      pages: '2 páginas',
      products: '4+ tipos',
      size: '1.0 MB',
      downloadUrl: '#',
      featured: false
    },
    {
      id: 11,
      title: 'Gelatinas sem Sabor',
      category: 'Sobremesas',
      image: 'https://placehold.co/400x600/ef4444/ffffff?text=Catálogo+Tecnutri',
      description: 'Gelatina incolor e sem sabor para preparações especiais e sobremesas personalizadas.',
      pages: '2 páginas',
      products: '2+ tipos',
      size: '0.8 MB',
      downloadUrl: '#',
      featured: false
    },
    {
      id: 12,
      title: 'Molho Escuro',
      category: 'Culinários',
      image: 'https://placehold.co/400x600/ef4444/ffffff?text=Catálogo+Tecnutri',
      description: 'Molho escuro concentrado para carnes e pratos quentes, sabor intenso.',
      pages: '2 páginas',
      products: '3+ variedades',
      size: '0.9 MB',
      downloadUrl: '#',
      featured: false
    },
    {
      id: 13,
      title: 'Molho Branco',
      category: 'Culinários',
      image: 'https://placehold.co/400x600/ef4444/ffffff?text=Catálogo+Tecnutri',
      description: 'Molho branco cremoso para massas e pratos especiais, textura aveludada.',
      pages: '2 páginas',
      products: '2+ variedades',
      size: '0.9 MB',
      downloadUrl: '#',
      featured: false
    },
    {
      id: 14,
      title: 'Creme de Cebola',
      category: 'Culinários',
      image: 'https://placehold.co/400x600/ef4444/ffffff?text=Catálogo+Tecnutri',
      description: 'Creme de cebola instantâneo, ideal para sopas e molhos cremosos.',
      pages: '2 páginas',
      products: '2+ tipos',
      size: '0.7 MB',
      downloadUrl: '#',
      featured: false
    },
    {
      id: 15,
      title: 'Panko Temperada',
      category: 'Culinários',
      image: 'https://placehold.co/400x600/ef4444/ffffff?text=Catálogo+Tecnutri',
      description: 'Farinha panko temperada para empanados crocantes e saborosos.',
      pages: '2 páginas',
      products: '3+ sabores',
      size: '0.8 MB',
      downloadUrl: '#',
      featured: false
    },
    {
      id: 16,
      title: 'Refresco 10 Litros',
      category: 'Bebidas',
      image: 'https://placehold.co/400x600/ef4444/ffffff?text=Catálogo+Tecnutri',
      description: 'Refresco em pó para preparo de 10 litros, linha completa de sabores.',
      pages: '4 páginas',
      products: '12+ sabores',
      size: '2.0 MB',
      downloadUrl: '#',
      featured: false
    },
    {
      id: 17,
      title: 'Catálogo Teste',
      category: 'Geral',
      image: 'https://placehold.co/400x600/ef4444/ffffff?text=Catálogo+Tecnutri',
      description: 'Catálogo de teste com produtos selecionados da linha Tecnutri.',
      pages: '8 páginas',
      products: '25+ produtos',
      size: '3.2 MB',
      downloadUrl: '#',
      featured: false
    }
  ];

  const featuredCatalogs = catalogs.filter(catalog => catalog.featured);
  const allCatalogs = catalogs;

  const handleDownload = (catalog: any) => {
    // Check if download URL is available
    if (catalog.downloadUrl === '#' || !catalog.downloadUrl || catalog.downloadUrl === '') {
      alert('Download não disponível no momento. Entre em contato conosco para solicitar este catálogo.');
      return;
    }
    
    // Create a temporary link element
    const link = document.createElement('a');
    link.href = catalog.downloadUrl;
    link.download = `${catalog.title}.${catalog.downloadUrl.split('.').pop()}`;
    link.target = '_blank';
    
    // Append to body, click, and remove
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    console.log(`Downloading: ${catalog.title}`);
  };

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const formData = new FormData();
      formData.append('nome', newsletterData.nome);
      formData.append('email', newsletterData.email);
      formData.append('empresa', newsletterData.empresa);
      formData.append('interesse', newsletterData.interesse);
      
      const response = await fetch('https://readdy.ai/api/form/d3m09ni96ie05rb9mf10', {
        method: 'POST',
        body: formData
      });
      
      if (response.ok) {
        setSubmitMessage('Cadastro realizado com sucesso! Você receberá nossos catálogos em breve.');
        setNewsletterData({ nome: '', email: '', empresa: '', interesse: '' });
        setTimeout(() => {
          setShowNewsletterModal(false);
          setSubmitMessage('');
        }, 3000);
      } else {
        setSubmitMessage('Erro ao enviar cadastro. Tente novamente.');
      }
    } catch (error) {
      setSubmitMessage('Erro ao enviar cadastro. Tente novamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleConsultoriaClick = () => {
    document.querySelector('#vapi-widget-floating-button')?.click();
  };

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section with Rotating Images */}
      <section className="relative py-32 overflow-hidden">
        {/* Image Carousel */}
        <div className="absolute inset-0">
          {heroImages.map((image, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === currentImageIndex ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <div
                className="w-full h-full bg-cover bg-center bg-no-repeat"
                style={{
                  backgroundImage: `url('${image}')`
                }}
              />
            </div>
          ))}
        </div>
        
        {/* Overlay with Link */}
        <Link to="/receitas" className="absolute inset-0 bg-black/15 cursor-pointer"></Link>
        
        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Nossos Catálogos
          </h1>
          <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto">
            Baixe nossos catálogos completos e conheça toda nossa linha de produtos TecNutri
          </p>
        </div>

        {/* Image Indicators */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20">
          <div className="flex space-x-2">
            {heroImages.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentImageIndex(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  index === currentImageIndex 
                    ? 'bg-white scale-125' 
                    : 'bg-white/50 hover:bg-white/75'
                }`}
              />
            ))}
          </div>
        </div>
      </section>

      <main className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Featured Catalogs */}
          <section className="mb-16">
            <div className="text-center mb-12">
              <span className="text-red-600 font-semibold text-lg">Principais</span>
              <h2 className="text-4xl font-bold text-gray-900 mt-2 mb-4">
                Catálogos em Destaque
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Nossos catálogos mais populares com os produtos essenciais para seu negócio
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {featuredCatalogs.map((catalog) => (
                <Card key={catalog.id} hover className="text-center group">
                  <div className="aspect-[3/4] mb-6 overflow-hidden rounded-lg bg-gray-100">
                    <img
                      src={catalog.image}
                      alt={catalog.title}
                      onError={(e) => {
                        const target = e.target as HTMLImageElement;
                        target.src = `https://placehold.co/400x600/ef4444/ffffff?text=${encodeURIComponent(catalog.title)}`;
                      }}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  
                  <div className="space-y-4">
                    <div>
                      <span className="inline-block px-3 py-1 bg-red-100 text-red-800 text-sm font-medium rounded-full mb-2">
                        {catalog.category}
                      </span>
                      <h3 className="font-semibold text-xl text-gray-900 mb-2">
                        {catalog.title}
                      </h3>
                      <p className="text-gray-600 mb-4">
                        {catalog.description}
                      </p>
                    </div>
                    
                    <div className="flex justify-center gap-6 text-sm text-gray-500 mb-6">
                      <span className="flex items-center">
                        <i className="ri-file-text-line mr-1"></i>
                        {catalog.pages}
                      </span>
                      <span className="flex items-center">
                        <i className="ri-shopping-bag-line mr-1"></i>
                        {catalog.products}
                      </span>
                      <span className="flex items-center">
                        <i className="ri-download-line mr-1"></i>
                        {catalog.size}
                      </span>
                    </div>
                    
                    <Button 
                      variant="primary" 
                      className="w-full"
                      onClick={() => handleDownload(catalog)}
                    >
                      <i className="ri-download-line mr-2"></i>
                      Download Gratuito
                    </Button>
                  </div>
                </Card>
              ))}
            </div>
          </section>

          {/* All Catalogs */}
          <section>
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Todos os Catálogos
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Explore nossa coleção completa de catálogos organizados por categoria
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {allCatalogs.map((catalog) => (
                <Card key={catalog.id} hover className="group">
                  <div className="flex gap-4">
                    <div className="w-24 h-32 flex-shrink-0 overflow-hidden rounded-lg bg-gray-100">
                      <img
                      src={catalog.image}
                      alt={catalog.title}
                      onError={(e) => {
                        const target = e.target as HTMLImageElement;
                        target.src = `https://placehold.co/400x600/ef4444/ffffff?text=${encodeURIComponent(catalog.title)}`;
                      }}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                    </div>
                    
                    <div className="flex-1 space-y-3">
                      <div>
                        <span className="inline-block px-2 py-1 bg-red-100 text-red-800 text-xs font-medium rounded-full mb-1">
                          {catalog.category}
                        </span>
                        <h3 className="font-semibold text-lg text-gray-900 group-hover:text-red-600 transition-colors">
                          {catalog.title}
                        </h3>
                        <p className="text-gray-600 text-sm line-clamp-2">
                          {catalog.description}
                        </p>
                      </div>
                      
                      <div className="flex flex-wrap gap-3 text-xs text-gray-500">
                        <span className="flex items-center">
                          <i className="ri-file-text-line mr-1"></i>
                          {catalog.pages}
                        </span>
                        <span className="flex items-center">
                          <i className="ri-shopping-bag-line mr-1"></i>
                          {catalog.products}
                        </span>
                        <span className="flex items-center">
                          <i className="ri-download-line mr-1"></i>
                          {catalog.size}
                        </span>
                      </div>
                      
                      <Button 
                        variant="outline" 
                        size="sm" 
                        className="w-full"
                        onClick={() => handleDownload(catalog)}
                      >
                        <i className="ri-download-line mr-2"></i>
                        Download
                      </Button>
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          </section>

          {/* Newsletter Section */}
          <section className="mb-16">
            <div className="bg-gradient-to-r from-red-600 to-red-700 rounded-2xl p-12 text-center text-white">
              <h3 className="text-3xl font-bold mb-4">
                Receba Nossos Catálogos por E-mail
              </h3>
              <p className="text-xl text-red-100 mb-8 max-w-2xl mx-auto">
                Cadastre-se e seja o primeiro a receber nossos novos catálogos e lançamentos
              </p>
              <Button 
                variant="outline" 
                size="lg" 
                className="border-white text-white hover:bg-white hover:text-red-600"
                onClick={() => setShowNewsletterModal(true)}
              >
                <i className="ri-mail-line mr-2"></i>
                Cadastrar Agora
              </Button>
            </div>
          </section>

          {/* Call to Action */}
          <div className="mt-16 bg-gradient-to-r from-red-600 to-red-700 rounded-2xl p-12 text-center text-white">
            <h3 className="text-3xl font-bold mb-4">
              Precisa de Mais Informações?
            </h3>
            <p className="text-xl text-red-100 mb-8 max-w-2xl mx-auto">
              Nossa equipe comercial está pronta para apresentar nossos produtos e soluções personalizadas
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                variant="outline" 
                size="lg" 
                className="border-white text-white hover:bg-white hover:text-red-600"
                onClick={handleConsultoriaClick}
              >
                <i className="ri-phone-line mr-2"></i>
                Falar com Consultor
              </Button>
              <Button 
                variant="outline" 
                size="lg" 
                className="border-white text-white hover:bg-white hover:text-red-600"
                onClick={() => setShowNewsletterModal(true)}
              >
                <i className="ri-mail-line mr-2"></i>
                Solicitar Apresentação
              </Button>
            </div>
          </div>

          {/* Benefits Section */}
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-download-cloud-line text-2xl text-red-600"></i>
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-2">Download Gratuito</h4>
              <p className="text-gray-600">Todos os nossos catálogos são gratuitos e estão sempre atualizados</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-refresh-line text-2xl text-red-600"></i>
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-2">Sempre Atualizados</h4>
              <p className="text-gray-600">Novos produtos e informações são adicionados regularmente</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-customer-service-line text-2xl text-red-600"></i>
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-2">Suporte Especializado</h4>
              <p className="text-gray-600">Nossa equipe está pronta para esclarecer dúvidas sobre os produtos</p>
            </div>
          </div>
        </div>
      </main>

      {/* Newsletter Modal */}
      {showNewsletterModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-md w-full p-8">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-2xl font-bold text-gray-900">Cadastre-se</h3>
              <button
                onClick={() => setShowNewsletterModal(false)}
                className="text-gray-400 hover:text-gray-600 text-2xl"
              >
                <i className="ri-close-line"></i>
              </button>
            </div>
            
            <form onSubmit={handleNewsletterSubmit} data-readdy-form className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Nome Completo *
                </label>
                <input
                  type="text"
                  name="nome"
                  required
                  value={newsletterData.nome}
                  onChange={(e) => setNewsletterData(prev => ({ ...prev, nome: e.target.value }))}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-4 focus:ring-red-300 focus:border-red-500"
                  placeholder="Seu nome completo"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  E-mail *
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  value={newsletterData.email}
                  onChange={(e) => setNewsletterData(prev => ({ ...prev, email: e.target.value }))}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-4 focus:ring-red-300 focus:border-red-500"
                  placeholder="seu@email.com"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Empresa
                </label>
                <input
                  type="text"
                  name="empresa"
                  value={newsletterData.empresa}
                  onChange={(e) => setNewsletterData(prev => ({ ...prev, empresa: e.target.value }))}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-4 focus:ring-red-300 focus:border-red-500"
                  placeholder="Nome da sua empresa"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Interesse Principal
                </label>
                <select
                  name="interesse"
                  value={newsletterData.interesse}
                  onChange={(e) => setNewsletterData(prev => ({ ...prev, interesse: e.target.value }))}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-4 focus:ring-red-300 focus:border-red-500 pr-8"
                >
                  <option value="">Selecione uma categoria</option>
                  <option value="bebidas">Bebidas e Refrescos</option>
                  <option value="sobremesas">Sobremesas</option>
                  <option value="culinarios">Produtos Culinários</option>
                  <option value="todos">Todos os Produtos</option>
                </select>
              </div>
              
              {submitMessage && (
                <div className={`p-3 rounded-lg text-sm ${
                  submitMessage.includes('sucesso') 
                    ? 'bg-green-100 text-green-800' 
                    : 'bg-red-100 text-red-800'
                }`}>
                  {submitMessage}
                </div>
              )}
              
              <Button 
                type="submit" 
                className="w-full" 
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <i className="ri-loader-4-line mr-2 animate-spin"></i>
                    Enviando...
                  </>
                ) : (
                  <>
                    <i className="ri-mail-send-line mr-2"></i>
                    Cadastrar
                  </>
                )}
              </Button>
            </form>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
